import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { api, session, setUnauthorizedHandler } from './api';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { LogsPage } from './pages/LogsPage';
import { NewPaymentPage } from './pages/NewPaymentPage';
import { OverviewPage } from './pages/OverviewPage';
import { PaymentDetailPage } from './pages/PaymentDetailPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { SettingsPage } from './pages/SettingsPage';

const DEFAULT_NAME = 'Payment Gateway';

export function App() {
  const [signedIn, setSignedIn] = useState(session.has);
  const [appName, setAppName] = useState(DEFAULT_NAME);

  const signOut = useCallback(() => {
    session.clear();
    setSignedIn(false);
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(() => setSignedIn(false));
  }, []);

  useEffect(() => {
    if (!signedIn) return;
    api
      .session()
      .then((s) => setAppName(s.appName))
      .catch(() => {
        /* 401 ຈະພາໄປໜ້າເຂົ້າສູ່ລະບົບເອງ */
      });
  }, [signedIn]);

  if (!signedIn) {
    return <LoginPage appName={appName} onSignedIn={() => setSignedIn(true)} />;
  }

  const page = (title: string, element: React.ReactNode) => (
    <Layout title={title} appName={appName} onSignOut={signOut}>
      {element}
    </Layout>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={page('ພາບລວມ', <OverviewPage />)} />
        <Route path="/payments" element={page('ປະຫວັດການຊຳລະ', <PaymentsPage />)} />
        <Route path="/payments/:paymentId" element={page('ລາຍລະອຽດ', <PaymentDetailPage />)} />
        <Route path="/new" element={page('ສ້າງ QR', <NewPaymentPage />)} />
        <Route path="/logs" element={page('ແຈ້ງເຕືອນ ແລະ Webhook', <LogsPage />)} />
        <Route path="/settings" element={page('ຕັ້ງຄ່າ', <SettingsPage />)} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
